import React, { useState, useEffect } from 'react';

import lips from "../icons/wired-outline-1558-shaving-foam-hover-pinch.json";
import styles from './FirstScreen.module.css';
import PinkScrollButton from '../components/button/Button';
import learn from "../icons/wired-outline-406-study-graduation-hover-pinch (1).json"
import middleImage from "../images/עידית בזק תמונה אמצעית.webp";
import rightImage from "../images/עידית בזק תמונה ימנית.webp"
import leftImage from "../images/עידית בזק תמונה שמאלית.webp"
import GradientLoader from '../components/loader/Loader';
import PinkScrollButtonOut from '../components/buttonOut/Button';
import { requestOpenMentoring } from '../utils/mentoringDrawer';
const FirstScreen = () => {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const imageUrls = [
      middleImage,
      rightImage,
      leftImage
    ];

    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        // Above the fold: tell the browser these outrank everything else.
        img.fetchPriority = 'high';
        img.decoding = 'async';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    };

    Promise.all(imageUrls.map(loadImage))
      .then(() => setImagesLoaded(true))
      .catch((err) => console.error("Failed to load images", err));
  }, []);

  if (!imagesLoaded) {
    return <GradientLoader/>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <div className={`${styles.backgroundImage} ${styles.leftImage}`}></div>
        <div className={`${styles.backgroundImage} ${styles.centerImage}`}></div>
        <div className={`${styles.backgroundImage} ${styles.rightImage}`}></div>
      </div>
      
      <div className={styles.contentBox}>
        <h1 className={styles.title}>IDIT BAZAK</h1>
  
        <div className={styles.buttonContainer}>
        <PinkScrollButton text="קורס ״מטפלות הפנים עולות שלב״" icon={learn} to="קורס"/>
        <PinkScrollButton text="אני רוצה לקבוע טיפול" icon={lips} to="טיפולים"/>
        <PinkScrollButtonOut text="קורס לימוד פילינג הקרבון" icon={learn} />
        <PinkScrollButton text="השתלמות 1:1 יחד איתי" icon={learn} onClick={requestOpenMentoring} />
        </div>
      </div>
    </div>
  );
};

export default FirstScreen;